import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { fromJS, isImmutable, List } from 'immutable';
import styled from 'styled-components';

// COMPONENTS
import DropdownMenu, { CLASSES } from 'components/DropdownMenu';
import { RadioButton } from 'components/RadioButtons';
import MaybeTranslation from 'components/MaybeTranslation';
import { CancelButton, PrimaryButton } from 'components/Buttons';

// STYLES
import {
  FilterFormContainer,
  FilterFormTitle,
  ButtonsContainer,
  RadioContainer,
  FilterItemGroup,
  FilterDropdownContainer,
} from './styles';

// CONSTANTS
import { FILTER_FORM } from 'constants/filters';
import { makeFilterRecord } from 'services/Views/reducer';
import { ifInTestingMode } from 'utils/tests.utils';

// UTILS

const PaddedRadioContainer = styled(RadioContainer)`
  margin-top: 5px;
  margin-bottom: 5px;
`;

class FuelDropdownConfiguration extends Component {
  state = {
    query: '',
    option: FILTER_FORM.fuelDropdown[0],
    dropdownItems: List(),
    selected: null,
  };

  componentDidMount() {
    // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
    let values = this.props.column.get('values');

    if (!values) {
      return;
    }

    if (!isImmutable(values)) {
      values = fromJS(values);
    }

    const dropdownItems = values
      .entrySeq()
      .map((entry) => {
        const [key, value] = entry;

        const item = fromJS({
          id: String(key),
          renderedValue: isImmutable(value) ? value.toJS() : value,
          value: key,
        });

        // @ts-expect-error TS(2339): Property 'set' does not exist on type 'Collection<... Remove this comment to see the full error message
        return item.set('handleClick', () => this.handleChangeValueSelection(item));
      })
      .toList()
      .filter((item) => item !== null);

    this.setState({
      dropdownItems,
      selected: dropdownItems.get(0),
    });
  }

  handleChangeComparatorSelection = (item) => {
    this.setState({ option: item });
  };

  handleChangeValueSelection = (item) => {
    this.setState({ selected: item });
  };

  handleSaveFilter = () => {
    const { selected } = this.state;

    if (selected !== null) {
      // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
      this.props.onSave(
        makeFilterRecord({
          comparator: this.state.option.comparator,
          // @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message
          field: this.props.column.get('name'),
          value: selected.get('value'),
        })
      );
    }
  };

  render() {
    return (
      <FilterFormContainer>
        <FilterFormTitle>
          {/* @ts-expect-error TS(2339): Property 'column' does not exist on type 'Readonly... Remove this comment to see the full error message */}
          <MaybeTranslation renderedValue={this.props.column.get('title')} />
        </FilterFormTitle>

        <FilterItemGroup>
          {FILTER_FORM.fuelDropdown.map((filterOption) => (
            <PaddedRadioContainer
              key={`fuel-filter-${filterOption.translation}`}
              onClick={() => this.handleChangeComparatorSelection(filterOption)}
            >
              <RadioButton
                // @ts-expect-error TS(2769): No overload matches this call.
                selected={filterOption.comparator === this.state.option.comparator}
                renderedValue={{
                  translationId: `components.Filters.${filterOption.translation}`,
                }}
              />
            </PaddedRadioContainer>
          ))}
          <FilterDropdownContainer>
            <DropdownMenu
              className={`${CLASSES.FULL_WIDTH}`}
              items={this.state.dropdownItems}
              button
              showSelected
              subtle
            />
          </FilterDropdownContainer>
        </FilterItemGroup>

        <ButtonsContainer>
          {/* @ts-expect-error TS(2339): Property 'onCancel' does not exist on type 'Readon... Remove this comment to see the full error message */}
          <CancelButton onClick={this.props.onCancel} />
          <PrimaryButton data-testid={ifInTestingMode('filters__apply')} onClick={this.handleSaveFilter}>
            <FormattedMessage id="components.Filters.apply" />
          </PrimaryButton>
        </ButtonsContainer>
      </FilterFormContainer>
    );
  }
}

export default FuelDropdownConfiguration;
